<template>
  <div>
    <b-form-group label="Origem:">
      <SelectTipoConcedente
        v-model="concedente.concedente_tipo_id"
        :state="validateState('concedente_tipo_id')"
      />
      <b-form-invalid-feedback
        >Tipo de Concedente é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Nome:">
      <b-overlay :show="verificandoNome" rounded="sm">
        <b-form-input
          v-model="concedente.nome"
          debounce="1500"
          placeholder="Nome"
          :state="validateState('nome')"
          @blur="verificarNome"
        />
        <b-form-invalid-feedback
          >Nome é um campo obrigatório.</b-form-invalid-feedback
        >

        <b-card v-if="concedentesNome.length" class="mt-4" header="">
          <template #header>
            <div class="d-flex">
              <h4 class="mb-0">
                Tem certeza que este concedente não é um desses a seguir ?
              </h4>

              <div class="table-actions ml-auto">
                <b-button @click="concedentesNome = []" variant="outline-exitos"
                  ><font-awesome-icon icon="times"
                /></b-button>
              </div>
            </div>
          </template>
          <b-table
            striped
            hover
            :items="concedentesNome"
            :fields="[
              { key: 'id', label: 'COD', class: 'col-1' },
              { key: 'nome', label: 'nome' },
              { key: 'actions', label: '#', class: 'col-1' },
            ]"
            class="table-concedentes"
          >
            <template #cell(actions)="{ item }">
              <div class="table-actions d-flex justify-content-end">
                <b-button
                  :to="{ name: 'concedentes_edit', params: { id: item.id } }"
                  variant="outline-exitos"
                  ><font-awesome-icon icon="edit"
                /></b-button>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-overlay>
    </b-form-group>

    <b-form-group label="Imagem de logo">
      <Arquivo v-model="concedente.imagem" type="image" />
    </b-form-group>

    <b-form-group label="Sobre :">
      <Editor v-model="concedente.sobre" />
    </b-form-group>
  </div>
</template>

<script>
import SelectTipoConcedente from "@/modules/tipos_concedentes/Components/SelectTipoConcedente.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import Editor from "@/components/Form/Editor.vue";
import Arquivo from "@/modules/files/Components/Arquivo.vue";

export default {
  components: { SelectTipoConcedente, Editor, Arquivo },
  mixins: [validationMixin],
  data: () => ({
    verificandoNome: false,
    concedentesNome: [],
  }),
  validations: {
    concedente: {
      concedente_tipo_id: { required },
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("concedentes", ["concedente"]),
  },
  methods: {
    ...mapActions("concedentes", ["ActionVerifyNome"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.concedente[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.concedente.$touch();
      return !this.$v.concedente.$anyError;
    },
    verificarNome() {
      this.verificandoNome = true;
      this.concedentesNome = [];

      this.ActionVerifyNome({
        id: this.concedente.id,
        nome: this.concedente.nome,
      })
        .then((data) => {
          this.concedentesNome = data;
        })
        .catch((error) => {
          this.$notifications.addNotification({
            message: "Erro ao carregar dados dos concedentes",
            type: "danger",
          });
        })
        .finally(() => {
          this.verificandoNome = false;
        });
    },
  },

  watch: {
    "concedente.imagem": {
      deep: true,
      handler: function (imagem) {
        this.concedente.imagem_id = imagem ? imagem.id : null;
      },
    },
  },
  created() {},
};
</script>

<style lang="scss">
.table-concedentes {
  td {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
    font-size: 0.8rem;
  }
}
</style>
